import { Component, OnInit } from '@angular/core';
import {ApiService} from "../../services/api.service";
import {ImportStatus} from "../../models/import-status";

@Component({
  selector: 'app-import-page',
  templateUrl: './import-page.component.html',
  styleUrls: ['./import-page.component.css']
})
export class ImportPageComponent implements OnInit {
  public importStatus: ImportStatus;

  constructor(private apiService:ApiService) { }

  ngOnInit(): void {
  }

  startImport() {
    console.log('startNewImport');
    this.importStep();
  }

  importStep(){
    this.apiService.getImportStep().subscribe(status=>{
      console.log(status);
      this.importStatus=status;
      if(status.progress<100) {
        this.importStep();
      }
    });
  }
}
